import { Link } from "react-router-dom";
import Seo, { orgSchema, breadcrumbSchema } from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { FadeUp } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
    return (
        <>
            <Seo
                title="Services — Custom Homes to Commercial | Dagaz Development"
                description="Nine service lines: custom homes, architecture, renovations, reconstructions, commercial, developer projects, audits, management and interior design. US & Canada."
                path="/services"
                jsonLd={[orgSchema, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])]}
            />
            <PageHeader
                eyebrow="Services — 09 Disciplines"
                titleLines={["Everything a building", "needs, under one roof."]}
                answer="Dagaz Development audits, designs and manages buildings across the United States and Canada — custom homes, renovations, reconstructions, commercial spaces and developer projects — delivered with licensed local builders, architects and suppliers in each state and province."
                crumbs={[{ name: "Services" }]}
            />
            <section className="px-6 md:px-12 lg:px-16 pb-28 md:pb-40 bg-chalk" data-testid="services-list">
                {SERVICES.map((s, i) => (
                    <FadeUp key={s.slug} delay={0.04 * i}>
                        <Link
                            to={`/services/${s.slug}`}
                            data-testid={`services-row-${s.slug}`}
                            className="group grid lg:grid-cols-12 items-center gap-6 py-10 border-t border-graphite/15 transition-all duration-500 hover:pl-4"
                        >
                            <span className="lg:col-span-1 font-sans text-[11px] font-medium tracking-[0.28em] text-slate">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="lg:col-span-5 font-serif font-light text-3xl md:text-5xl text-graphite group-hover:italic transition-all duration-500">
                                {s.name}
                            </span>
                            <span className="lg:col-span-4 font-sans text-sm leading-relaxed text-slate max-w-sm">
                                {s.short}
                            </span>
                            <span className="hidden lg:flex lg:col-span-2 justify-end items-center gap-3">
                                <span className="w-28 h-20 overflow-hidden">
                                    <img src={s.image} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                                </span>
                                <span className="text-gold transition-transform duration-500 group-hover:translate-x-1.5" aria-hidden="true">→</span>
                            </span>
                        </Link>
                    </FadeUp>
                ))}
                <div className="border-t border-graphite/15" />
            </section>
        </>
    );
}
